import type { MouseEvent } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { flexRender, type Row as TRow } from '@tanstack/react-table';
export type RowProps<T extends object> = {
  row: TRow<T>;
  onClickRow?: (event: MouseEvent<HTMLTableRowElement>, row: TRow<T>) => void;
};

const Row = <T extends object>({ row, onClickRow }: RowProps<T>) => {
  const cells = row.getVisibleCells();
  return (
    <TableRow
      hover={!!onClickRow}
      onClick={onClickRow ? (event) => onClickRow(event, row) : undefined}
    >
      {cells.map((cell) => (
        <TableCell
          align={cell.column.columnDef.meta?.align}
          key={cell.id}
          sx={{ verticalAlign: 'top' }}
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </TableCell>
      ))}
    </TableRow>
  );
};
export default Row;
